import type { ReactNode } from 'react';
import * as Sentry from '@sentry/react';

import { EMPTY_STRING } from '@e-socna/empty';

import { useAuthenticationContext } from '../contexts/AuthenticationContext/hooks/useAuthenticationContext.hook';
import { locales } from '../utils/locales.util';

interface Props {
  readonly children: ReactNode;
}

export const SentryWrapper = ({ children }: Readonly<Props>) => {
  const { authenticationData } = useAuthenticationContext();

  const user = authenticationData?.email
    ? {
        email: authenticationData.email,
        name: `${authenticationData.person.firstName ? `${authenticationData.person.firstName} ` : EMPTY_STRING}${authenticationData.person.lastName}`,
      }
    : undefined;

  return (
    <Sentry.ErrorBoundary
      dialogOptions={{
        user,
        lang: locales.fr,
      }}
      showDialog
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};
